module.exports = __webpack_public_path__ + "static/media/iboss.06e7a61e.svg";